@if(props.label) {
    <div class="p-field">
        <label>{{props.label}}</label>
        <p-inputnumber [formlyAttributes]="field"
                [formControl]="formControl"
                [max]="props.max"
                [min]="props.min"
                [useGrouping]="inputUseGrouping"
                [mode]="inputMode"
                [locale]="inputLocale"
                [currency]="inputCurrency"
                [suffix]="inputSuffix"
                [prefix]="inputPrefix"
                [minFractionDigits]="minFractionDigits"
                [maxFractionDigits]="maxFractionDigits"
                [fluid]="true" />
        @if(showError) {
            <small class="p-error">
                <formly-validation-message [field]="field" />
            </small>
        }
    </div>
} @else {
    <p-inputnumber [formlyAttributes]="field"
                [formControl]="formControl"
                [max]="props.max"
                [min]="props.min"
                [useGrouping]="inputUseGrouping"
                [mode]="inputMode"
                [locale]="inputLocale"
                [currency]="inputCurrency"
                [suffix]="inputSuffix"
                [prefix]="inputPrefix"
                [minFractionDigits]="minFractionDigits"
                [maxFractionDigits]="maxFractionDigits"
                [fluid]="true" />
    @if(showError) {
        <small class="p-error">
            <formly-validation-message [field]="field" />
        </small>
    }
}


